const reasons = [
  {
    icon: 'ri-map-pin-2-line',
    title: '名古屋16区の地元ネットワーク',
    desc: '地元密着だからこそ知っているエリア相場・需要・タイミング。地域の実情に合わせた最適なご提案が可能です。',
  },
  {
    icon: 'ri-lock-2-line',
    title: '秘密厳守・プライバシー配慮',
    desc: '近所への告知なし、ご家族への配慮も徹底。売却の事実が外部に漏れないよう、細心の注意を払います。',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'スピード対応・柔軟な提案',
    desc: '急な現金化にも対応。状況に応じて買取・売却・仲介など最適な方法をご提案します。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '宅建業者として適切な手続き',
    desc: '愛知県知事免許取得済。法的に適切な手続きで、安心・安全な取引をサポートします。',
  },
  {
    icon: 'ri-global-line',
    title: '全国どこからでも相談OK',
    desc: '遠方にお住まいの方も、オンライン・電話でのご相談に対応。まずはお気軽にどうぞ。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '押し売り一切なし',
    desc: '査定後の売却は完全にお客様の意思次第。相談・査定だけでも大歓迎です。',
  },
];

export default function ReasonsSection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1fffe658dd46bc9357043a40d3b7e643.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#0D1B2E]/88" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-10 bg-emerald-400" />
              <span className="text-emerald-400 text-xs font-semibold tracking-[0.2em] uppercase">Why Choose Us</span>
            </div>
            <h2 className="text-white text-2xl md:text-4xl font-bold leading-tight">
              選ばれる理由
            </h2>
          </div>
          <p className="text-white/50 text-sm max-w-xs leading-relaxed">
            地元密着・秘密厳守・スピード対応。<br />
            お客様の状況に合わせた最適なご提案をします。
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-white/5 hover:bg-white/10 border border-white/10 hover:border-emerald-400/30 rounded-2xl p-7 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/10 group-hover:bg-emerald-500/20 rounded-xl mb-5 transition-colors duration-300">
                <i className={`${reason.icon} text-emerald-400 text-2xl`} />
              </div>
              <h3 className="text-white font-bold text-base mb-3 leading-snug">{reason.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{reason.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}